import { Component } from '@angular/core';
import { IzzySkillEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Skills') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyskill-form',
    templateUrl: './izzyskill.form.component.html'
})
export class IzzySkillFormComponent extends BaseFormComponent {
    public record!: IzzySkillEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'organization', sectionName: 'Organization', isExpanded: true },
            { sectionKey: 'skillDetails', sectionName: 'Skill Details', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false },
            { sectionKey: 'personSkills', sectionName: 'Person Skills', isExpanded: false },
            { sectionKey: 'skillIssueTypes', sectionName: 'Skill Issue Types', isExpanded: false }
        ]);
    }
}

